import { Image } from 'antd';
import type { ImageProps } from 'antd';

export interface DImageProps extends ImageProps {}

export const DarwinImage = (props: DImageProps) => {
  return <Image {...props} />;
};
